import React, { useEffect, useState } from 'react';
import { IPropertyWizardInput } from './NewPropertyWizard';
// import { CKEditor, CKEditorEventPayload } from '@ckeditor/ckeditor5-react';
import LoadingIndicator from '../LoadingIndicator';
import PropertyRequest from '../../utils/PropertyRequest';
// import { styles } from '../../../node_modules/ansi-colors/types/index';
import styles from './PropertyDescription.scss';
import { joditEditorConfig } from '../UserPage/FieldModal';
import JoditEditor from 'jodit-react';
import cx from '../../utils/cx';

export type IPropertyDescriptionProps = IPropertyWizardInput

const currJoditEditorConfig = {
    ...joditEditorConfig,
    buttons: ['bold', 'italic', '|', 'ul', 'ol'],
}

const PropertyDescription: React.FC<React.PropsWithChildren<IPropertyDescriptionProps>> = ({ step = null, data = null, features = null, onChange = () => { } }) => {
    
    const [text, setText] = useState( data[step.name]?.['value'] || (typeof data[step.name] === 'string' ? data[step.name] : ''));
    const [isLoading, setIsLoading] = useState(!text);

    useEffect(() => {
        if (!text && step.name === 'objektbeschreibung') {
            PropertyRequest.getDefaultPropertyDescription(data, features)
                .then((res) => {
                    const data = res.getData();
                    if (data.description) {
                        setText(data.description);
                        onChange(step.name, data.description);
                    } else {
                        console.warn('getDefaultPropertyDescription without description', res);
                    }
                    setIsLoading(false);
                })
                .catch((e) => {
                    setIsLoading(false);
                    console.error(e);
                });
        } else {
            if (isLoading) {
                setIsLoading(false);
            }
        }
    }, []);

    // const handleEditorChange = (ev: CKEditorEventPayload<'change'>) => {
    //     const value = ev.editor.getData();
    //     onChange(step.name, value);
    // };
    const handleEditorChange = (value) => {
        // remove line-breaks that are shown in expose, but not in the editor (see WGLDE-4804)
        onChange(step.name, value.replace(/(\r\n|\n\r|\r|\n)/g, ' ').trim());
    };

    return (
        <div className={cx(styles.propertyDescription, 'prose','read-more',  isLoading ? styles.isLoading : null)}>
            {isLoading ? (
                <LoadingIndicator />
            ) : (
                <JoditEditor
                    className='content'
                    value={text || ''}
                    config={currJoditEditorConfig}
                    onBlur={handleEditorChange} // preferred to use only this option to update the content for performance reasons
                // onChange={newContent => { }}
                />
                // <CKEditor
                //     initData={text}
                //     onChange={(ev) => {
                //         handleEditorChange(ev);
                //     }}
                //     config={
                //         // user.isAdmin
                //         //     ? { contentsCss: '/themes/custom/dnz_emulsify/dist/style.css' }
                //         //     :
                //         {
                //             toolbar: [
                //                 ['Bold', 'Italic'],
                //                 ['BulletedList', 'NumberedList'],
                //             ],
                //             contentsCss: '/themes/custom/dnz_emulsify/dist/style.css',
                //         }
                //     }
                // />
            )}
        </div>
    );
};

export default PropertyDescription;
